var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[(_vm.stickyToasts.length > 0)?_c('button',{ref:"closeAllBtn",staticClass:"close-all-btn",on:{"click":_vm.closeAll}},[_vm._v(" ✕ Close all ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }